import { supabase } from "../lib/supabase";
import { get, writable, type Writable } from "svelte/store";
import type { User, UserResponse } from "@supabase/supabase-js";
import { localStorageWritable } from "./localStorageWritable";

// User store
export const user: Writable<User | null> = writable();

export const isSubscribedToJobAlert = localStorageWritable(
	"isSubscribedToJobAlert",
	false
);

export const getUser = async () => {
	const hasSession = await supabase.auth.getSession();

	if (!hasSession) {
		user.set(null);
		return;
	}

	if (get(user)) {
		return get(user);
	} else {
		const result = await supabase.auth.getUser();

		if (result.error || !result.data.user) {
			return null;
		}
		user.set(result.data.user);
		return result.data.user;
	}
};

export const signOut = async () => {
	await supabase.auth.signOut();
	user.set(null);
};

export const updateUser = async (input: {
	data?: {
		phone?: string | null;
		factorIds?: number[] | null;
		sectorIds?: number[] | null;
		firstName?: string | null;
		lastName?: string | null;
	};
}) => {
	const currentSession = await supabase.auth.getSession();

	const currentSessionData = {
		data: {
			...currentSession.data.session?.user.user_metadata
		}
	};

	if (input?.data?.phone) {
		currentSessionData.data.phone = input.data.phone;
	}
	if (input?.data?.factorIds) {
		currentSessionData.data.factorIds = input.data.factorIds;
	}
	if (input?.data?.sectorIds) {
		currentSessionData.data.sectorIds = input.data.sectorIds;
	}
	if (input?.data?.firstName) {
		currentSessionData.data.firstName = input.data.firstName;
	}
	if (input?.data?.lastName) {
		currentSessionData.data.lastName = input.data.lastName;
	}

	try {
		const { data, error } = await supabase.auth.updateUser(currentSessionData);

		if (error) {
			return {
				error: true,
				success: false,
				data
			};
		}

		user.set(data.user);

		return {
			error: false,
			success: true,
			data
		};
	} catch (err) {
		return {
			error: true,
			success: false
		};
	}
};

export const isProfileComplete = async (user: UserResponse) => {
	if (!user.data.user?.user_metadata?.firstName) {
		return false;
	}
	if (!user.data.user?.user_metadata?.lastName) {
		return false;
	}

	return true;
};
